import { render, staticRenderFns } from "./ViewSettings.vue?vue&type=template&id=3692f8a4&"
import script from "./ViewSettings.vue?vue&type=script&lang=js&"
export * from "./ViewSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports